/**
 * Created by quikr on 1/5/17.
 */
import React, {PropTypes} from "react";
import Modal from "react-bootstrap/lib/Modal";
import axios from "axios";
import toastr from "toastr";


class ModalConfirm extends React.Component {

  constructor() {
    super();
    this.state = {doR: null, comment: null, error: null}

  }

  render() {
    console.log(this.state);
    return (
      <Modal
        bsSize="small"
        show={this.props.open} onHide={this.props.close}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Exit</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Date of Resignation: {new Date(this.props.employee.doResignation).toLocaleDateString('en-GB')}</p>
          <p>Last Working
            Day: {this.props.employee.doLeaving != null ? new Date(this.props.employee.doLeaving).toLocaleDateString('en-GB') : null}</p>


          <br/>

          {this.props.employee.managerStatus == 'pending' ? <div>
            <p style={{color: 'red'}}>*You can confirm exit only on the last working day</p>


            <button className="btn btn-default btn-block" onClick={()=> {
              if (this.props.employee.doLeaving == null) {
                toastr.error("Exit Process Incomplete");
              }
              else {
                let doL = new Date(this.props.employee.doLeaving);
                let todayDate = new Date();
                if (todayDate < doL) {
                  toastr.error("You Can Confirm Exit Only On The Last Working Day")
                }
                else {
                  let request = new Object();
                  request.id = this.props.employee.id;
                  request.empId = this.props.employee.employeeCode;
                  request.status = "completed";
                  axios.post(process.env.REQ_URL + "/exit/changeManagerStatus", {data: request}, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
                    this.props.close();
                    this.props.refresh();
                    toastr.success("Exit Confirmed")

                  }).catch((err)=> {
                    toastr.error("Error Occurred");

                  });

                }

              }
            }}>Yes
            </button>

          </div> : <p style={{color: 'red', size: '15px'}}>Confirmed</p>}
          <br/>
          <button
            onClick={()=> {
              this.props.close();
            }}
            className="btn btn-default btn-block">Cancel
          </button>
        </Modal.Body>
      </Modal>
    );
  }
}

ModalConfirm.propTypes = {};

export default ModalConfirm;





/** WEBPACK FOOTER **
 ** ./src/feature/myProfile/ManagerSS/Modals/ModalConfirm.js
 **/